import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var FileCode02 = function FileCode02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M5 18.5c0 .4644 0 .6966.0257.8916.1772 1.3462 1.2365 2.4055 2.5827 2.5827C7.8034 22 8.0356 22 8.5 22h7.7c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.7202 21 18.8802 21 17.2V9.9882c0-.7338 0-1.1006-.0829-1.4459a3 3 0 0 0-.3592-.8671c-.1855-.3028-.4449-.5622-.9638-1.081l-3.1882-3.1883c-.5189-.5189-.7783-.7783-1.081-.9638a3 3 0 0 0-.8672-.3592C14.1124 2 13.7455 2 13.0118 2H8.5c-.4644 0-.6966 0-.8916.0257-1.3462.1772-2.4055 1.2365-2.5827 2.5827C5 4.8034 5 5.0356 5 5.5m4 9 2.5-2.5L9 9.5m-4 0L2.5 12 5 14.5"
    })
  }));
};
export default FileCode02;